import { useEffect, useState } from 'react';
import { isAbortError } from '../services/apiClient';

export function useCreditorListData({
  app,
  companyId,
  page,
  qDebounced,
  status,
  supplier,
  employee,
  creditorsListTick,
}) {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [payload, setPayload] = useState(null);
  const [creditorKpis, setCreditorKpis] = useState(null);
  const [creditorKpisLoading, setCreditorKpisLoading] = useState(true);
  const [creditorKpisErr, setCreditorKpisErr] = useState(null);

  useEffect(() => {
    if (!companyId || !app.authToken) {
      setCreditorKpis(null);
      setCreditorKpisErr(null);
      setCreditorKpisLoading(false);
      return undefined;
    }
    const ac = new AbortController();
    (async () => {
      setCreditorKpisLoading(true);
      setCreditorKpisErr(null);
      try {
        const data = await app.fetchCompanyCreditorsKpis(companyId, { signal: ac.signal });
        setCreditorKpis(data);
      } catch (e) {
        if (isAbortError(e)) return;
        setCreditorKpisErr(e.message || 'Não foi possível carregar os KPIs.');
        setCreditorKpis(null);
      } finally {
        if (!ac.signal.aborted) setCreditorKpisLoading(false);
      }
    })();
    return () => {
      ac.abort();
    };
  }, [companyId, creditorsListTick, app.authToken]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!companyId || !app.authToken) {
      setPayload(null);
      return undefined;
    }
    const ac = new AbortController();
    (async () => {
      setLoading(true);
      setErr(null);
      try {
        const query = { page: String(page), per_page: '20' };
        if (qDebounced) query.q = qDebounced;
        if (status) query.status = status;
        if (supplier) query.supplier = supplier;
        if (employee) query.employee = employee;
        const data = await app.fetchCompanyCreditors(companyId, query, { signal: ac.signal });
        setPayload(data);
      } catch (e) {
        if (isAbortError(e)) return;
        setErr(e.message || 'Falha ao carregar credores');
        setPayload(null);
      } finally {
        if (!ac.signal.aborted) setLoading(false);
      }
    })();
    return () => {
      ac.abort();
    };
  }, [companyId, page, qDebounced, status, supplier, employee, creditorsListTick, app.authToken]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    loading,
    err,
    payload,
    creditorKpis,
    creditorKpisLoading,
    creditorKpisErr,
  };
}
